import { faTrash } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button, Popconfirm, Tooltip } from "antd"
import { useContext } from "react"
import { ItemsContext } from "../Items/ItemsRoot"
import { ProjectTypes } from "../../common/constants"
import { useDeleteJobCheckQuery, useDeleteJobMutation } from "../../domain/jobs/jobsQueries"

type Props = {
  jobId: number
}

const DeleteJob = ({ jobId }: Props) => {
  const { jobData } = useContext(ItemsContext)
  const deleteJobCheckQuery = useDeleteJobCheckQuery(jobId)
  const deleteJobMutation = useDeleteJobMutation()

  const isDisabled = deleteJobMutation.isLoading || deleteJobCheckQuery.isLoading || (deleteJobCheckQuery.data !== true)

  const buildTooltipText = () => {
    if (deleteJobMutation.isLoading) {
      return 'Deleting the job...'
    }

    return deleteJobCheckQuery.isLoading
      ? 'Checking if job may be deleted...'
      : 'This job has invoices. They must be deleted before the job can be deleted.'
  }

  const handleDelete = () => {
    deleteJobMutation.mutate(jobId, {
      onSuccess: () => {
        window.location.href = getDestination()
      }
    })
  }

  const getDestination = () => {
    if (!jobData.jobIsSold) {
      return '/#!/estimates'
    }

    switch (jobData.jobType) {
      case ProjectTypes.Maintenance:
        return '/#!/maintenance'
      case ProjectTypes.Ticket:
        return '/#!/tickets'
      default:
        return '/#!/projects'
    }
  }

  const button = <Button
    type="primary"
    size="large"
    danger
    icon={<FontAwesomeIcon icon={faTrash} />}
    disabled={isDisabled}
    loading={deleteJobMutation.isLoading}
  >Delete job</Button>

  return isDisabled
  ? <Tooltip title={buildTooltipText()}>{button}</Tooltip>
  : <Popconfirm
      title={"Delete this job?"}
      description={"This cannot be undone and will remove all information regarding this job."}
      okText="Delete"
      onConfirm={handleDelete}
    >{button}</Popconfirm>
}

export default DeleteJob
